const BoxRight = (props) => {

    return <>
        <div className="boxright  w-full md:w-3/5">
            {props.children}
        </div>
    </>
}

export default BoxRight;